module.exports = __webpack_public_path__ + "img/2.a16dd306.png";